import _truncate from 'lodash/truncate';

const DEFAULT_TRUNCATION_LENGTH = 160;

export function truncate(
  content: string,
  length = DEFAULT_TRUNCATION_LENGTH,
  separator = ' '
) {
  if (content.length < length) {
    return content;
  }
  return _truncate(content, {
    length,
    separator,
  });
}

/**
 * Executes a simple character count based truncation.
 * E.g. MyCustomString -> My...String
 * @param content - The original string
 * @param lengthLeft - The number of characters to leave in the beginning
 * @param lengthRight - The number of characters to leave at the end
 * @param separator - Separator characters
 */
export function truncateMiddle({
  content,
  lengthLeft,
  lengthRight,
  separator = '...',
}: {
  content: string;
  lengthLeft: number;
  lengthRight: number;
  separator?: string;
}) {
  // Only truncate when doing so actually shortens the string. Without
  // accounting for the separator, short inputs get "truncated" into something
  // longer than the original (e.g. "ghi-sku" -> "gh...i-sku").
  if (
    lengthLeft < 0 ||
    lengthRight < 0 ||
    content.length <= lengthLeft + lengthRight + separator.length
  ) {
    return content;
  }

  const left = content.substring(0, lengthLeft);
  const right = content.substring(content.length - lengthRight);

  return `${left}${separator}${right}`;
}
